"use strict";
/**
 * There is a cookie consent partial
 * in the layout page. These functions run immediately on load
 * and check to see if the cookies have been accepted or not.
 *
 * */
$(function () {
    checkCookiePolicy();
});
function checkCookiePolicy() {
    var savedCookiePolicyResponse = localStorage.getItem("acceptedCookiePolicy");
    if (!savedCookiePolicyResponse || savedCookiePolicyResponse !== "true") {
        $(".cookie-policy-message-container").show();
    }
}
window.acceptCookiePolicy = function () {
    localStorage.setItem("acceptedCookiePolicy", "true");
    $(".cookie-policy-message-container").slideUp("slow");
};
